import { render, staticRenderFns } from "./POView.vue?vue&type=template&id=637d24d4&scoped=true&"
import script from "./POView.vue?vue&type=script&lang=js&"
export * from "./POView.vue?vue&type=script&lang=js&"
import style0 from "./POView.vue?vue&type=style&index=0&id=637d24d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d24d4",
  null
  
)

export default component.exports